<!--Main-->
<template>
  <div class="table-content" :class="className" v-if="data">
    <!-- 显示表格 -->
    <el-table
      ref="multipleTable"
      :key="tableKey"
      v-loading="listInfo.loading"
      :max-height="tableHeight || undefined"
      :data="data"
      :span-method="handle && handle.spanMethod"
      border
      style="width: 100%"
      element-loading-text="Loading"
      fit
      size="mini"
      highlight-current-row
      @select-all="handleSelectionChange"
      @selection-change="handleSelectionChange"
    >
      <template v-for="(item, index) in fieldList">
        <template v-if="item.show">
          <!-- 多选框按钮 -->
          <el-table-column
            v-if="item.btType == 'selection'"
            :key="index"
            type="selection"
            width="55"
            :selectable="item.event"
          />
          <!-- 图标按钮 -->
          <el-table-column
            v-else-if="item.btType == 'actions'"
            :key="index"
            :prop="item.prop"
            :label="$t(item.label)"
            :fixed="item.fixed"
            :type="item.type"
            :width="item.width"
            :min-width="item.minWidth || '100px'"
            :formatter="item.formatter"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <template v-for="(bt, i) in handle.btList">
                <el-popover
                  v-if="
                    bt.show !== false &&
                    bt.type === 'qr' &&
                    (!data[scope.$index].btns ||
                      (data[scope.$index].btns &&
                        data[scope.$index].btns[i] !== false))"
                  placement="bottom"
                  width="240"
                  trigger="click"
                  style="margin-left: 10px"
                  @show="createQrcode(`qrCodeDiv_${scope.$index}`, data[scope.$index].qrData)"
                >
                  <div class="qrPic">
                    <div :ref="`qrCodeDiv_${scope.$index}`"></div>
                  </div>
                  <div class="text-center"><el-button type="success" @click="saveQrImg(`qrCodeDiv_${scope.$index}`)">下载二维码</el-button></div>
                  <span slot="reference" class="link"><svg-icon icon-class="qr" style="color:#005f9e" /></span>
                </el-popover>
                <el-tooltip
                  v-if="
                    bt.show != false &&
                    (!data[scope.$index].btns ||
                      (data[scope.$index].btns &&
                        data[scope.$index].btns[i] !== false))
                  "
                  :key="i"
                  :content="$t((data[scope.$index].btns && data[scope.$index].btns[i] && data[scope.$index].btns[i].tips) || bt.label)"
                  :disabled="
                    scope.row.btns &&
                    scope.row.btns[i] &&
                    scope.row.btns[i].disabled
                  "
                  placement="bottom-start"
                >
                  <el-link
                    :icon="bt.icon"
                    :type="bt.type"
                    :style="`margin-left: 3px;${bt.style};${
                      scope.row.btns &&
                      scope.row.btns[i] &&
                      scope.row.btns[i].disabled
                        ? 'color: #888;'
                        : ''
                    }`"
                    :underline="false"
                    :disabled="
                      scope.row.btns &&
                      scope.row.btns[i] &&
                      scope.row.btns[i].disabled
                    "
                    @click="handleClick(bt.event, scope.row)"
                    ><span
                      style="color: #e65d6e"
                      v-if="scope.row.noReadTicketLogNum > 0"
                      >({{ scope.row.noReadTicketLogNum }})</span
                    ></el-link
                  >
                </el-tooltip>
              </template>
            </template>
          </el-table-column>

          <!-- 自定义按钮,订单管理订单取消状态高亮提示按钮 -->
          <el-table-column
            v-else-if="item.btType == 'status'"
            :key="index"
            :prop="item.prop"
            :label="$t(item.label)"
            :fixed="item.fixed"
            :type="item.type"
            :width="item.width"
            :min-width="item.minWidth || '100px'"
            :formatter="item.formatter"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
               <span
                 :style="`color: ${scope.row[item.prop + 'ShowColor'] || scope.row.showColor ? item.color : ''};`"
               >{{scope.row[item.prop]}}</span>
              <!-- 文字link后面加按钮操作hover后Popover 弹出框   scope.row.cancelReasonName &&-->
              <el-popover v-if="scope.row.schOrderStatusName =='已取消'" trigger="hover" placement="right">
                  <li>{{scope.row.cancelReasonName}}</li>
                <el-link
                  v-if="item.btIcon"
                  slot="reference"
                  :icon="item.btIcon"
                  :underline="false"
                  style="color: rgb(255, 140, 0)"
                ></el-link>
              </el-popover>
            </template>
          </el-table-column>
          <!-- 链接按钮 -->
          <el-table-column
            v-else-if="item.btType == 'link'"
            :key="index"
            :prop="item.prop"
            :label="$t(item.label)"
            :fixed="item.fixed"
            :type="item.type"
            :width="item.width"
            :min-width="item.minWidth || '100px'"
            :formatter="item.formatter"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="handleClick(item.event, scope.row)"
                >{{ scope.row[item.prop] }}</el-link
              >
              <!-- 文字link后面加按钮操作hover后Popover 弹出框 -->
              <el-popover v-if="scope.row.schOrderWarnPOS && scope.row.schOrderWarnPOS.length" trigger="hover" placement="right">
                <ul class="tagDesc" v-for="(item,index) in scope.row.schOrderWarnPOS" :key="index">
                  <li>{{item.warnTypeName}}</li>
                </ul>
                <el-link
                  v-if="item.btIcon"
                  slot="reference"
                  :icon="item.btIcon"
                  :underline="false"
                  style="color: rgb(255, 140, 0)"
                ></el-link>
              </el-popover>
              <el-popover v-else-if="scope.row.tips" trigger="hover" placement="right">
                <ul class="tagDesc">
                  <li>{{scope.row.tips}}</li>
                </ul>
                <el-link
                  v-if="item.btIcon"
                  slot="reference"
                  :icon="item.btIcon"
                  :underline="false"
                  style="color: rgb(255, 140, 0)"
                ></el-link>
              </el-popover>
            </template>
          </el-table-column>
          <!-- 链接按钮组 -->
          <el-table-column
            v-else-if="item.btType == 'links'"
            :key="index"
            :prop="item.prop"
            :label="$t(item.label)"
            :fixed="item.fixed"
            :type="item.type"
            :width="item.width"
            :min-width="item.minWidth || '100px'"
            :formatter="item.formatter"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-link
                v-for="(linkItem, linkIndex) in scope.row.linkList"
                :key="linkIndex"
                type="primary"
                :underline="false"
                @click="handleClick(item.event, { ...scope.row, linkIndex })"
                >{{ linkItem
                }}<span
                  v-if="
                    scope.row.linkList.length > 1 &&
                    linkIndex < scope.row.linkList.length - 1
                  "
                  >,</span
                ></el-link
              >
            </template>
          </el-table-column>

          <template v-else>
            <el-table-column
              v-if="item.type == 'index'"
              :key="index"
              :prop="item.prop"
              :label="$t(item.label)"
              :fixed="item.fixed"
              :type="item.type"
              :width="item.width"
              :min-width="item.minWidth || '100px'"
              :formatter="item.formatter"
              show-overflow-tooltip
            />
            <el-table-column
              v-else
              :key="index"
              :prop="item.prop"
              :label="$t(item.label)"
              :fixed="item.fixed"
              :type="item.type"
              :width="item.width"
              :min-width="item.minWidth || '100px'"
              :formatter="item.formatter"
              show-overflow-tooltip
            >
<!--              <template slot-scope="scope">-->
<!--                <span-->
<!--                  :style="`color: ${-->
<!--                    scope.row[item.prop + 'ShowColor'] &&-->
<!--                    (item.color || scope.row[item.prop + 'Color'])-->
<!--                  };`"-->
<!--                  >{{ scope.row[item.prop] }}</span-->
<!--                >-->
<!--              </template>-->
              <template slot-scope="scope">
                <span
                  :style="`color: ${scope.row[item.prop + 'ShowColor'] || scope.row.showColor ? item.color : ''};`"
                >{{scope.row[item.prop]}}</span>
              </template>

            </el-table-column>
          </template>
        </template>
      </template>
    </el-table>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
export default {
  name: "Main",
  props: {
    // 自定义类名
    className: {
      type: String,
    },
    // 类型列表
    listTypeInfo: {
      type: Object,
    },
    // 表格字段配置
    fieldList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 操作栏配置
    handle: {
      type: Object,
    },
    // 列表数据
    data: {
      type: Array,
    },
    //table标识
    tableKey: {
      type: Number,
    },
    // 监听高度
    height: {
      type: Number,
      default: 500,
    },
    contentHeight: {
      type: Number,
      default: 550,
    },
    toggleRowSelections: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      // 列表相关
      listInfo: {
        loading: false, // 加载动画
      },
      tableHeight: 0,
      qrCode: null
    };
  },
  watch: {
    height(value) {
      const navH = document.getElementsByClassName("navbar")[0]
        ? document.getElementsByClassName("navbar")[0].clientHeight
        : 0;
      const tagH = document.getElementsByClassName("tags-view-container")[0]
        ? document.getElementsByClassName("tags-view-container")[0].clientHeight
        : 0;
      const searchH = document.getElementsByClassName(
        "fn-layout-vertical-form"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-form")[0]
            .clientHeight
        : 0;
      const pagerH = document.getElementsByClassName(
        "fn-layout-vertical-operation"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-operation")[0]
            .clientHeight
        : 0;
      const bottomH = document.getElementsByClassName(
        "fn-layout-vertical-pagination"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-pagination")[0]
            .clientHeight
        : 0;
      const customHeader = document.getElementsByClassName(
        "table-custom-header "
      )[0]
        ? document.getElementsByClassName("table-custom-header ")[0]
            .clientHeight
        : 0;
      if (value) {
        this.tableHeight =
          window.innerHeight -
          (navH + tagH + searchH + pagerH + bottomH + customHeader);
      }
    },
    contentHeight(value) {
      const navH = document.getElementsByClassName("navbar")[0]
        ? document.getElementsByClassName("navbar")[0].clientHeight
        : 0;

      const tagH = document.getElementsByClassName("tags-view-container")[0]
        ? document.getElementsByClassName("tags-view-container")[0].clientHeight
        : 0;
      const searchH = document.getElementsByClassName(
        "fn-layout-vertical-form"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-form")[0]
            .clientHeight
        : 0;
      const pagerH = document.getElementsByClassName(
        "fn-layout-vertical-operation"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-operation")[0]
            .clientHeight
        : 0;
      const bottomH = document.getElementsByClassName(
        "fn-layout-vertical-pagination"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-pagination")[0]
            .clientHeight
        : 0;

      const tabH = document.getElementsByClassName("el-tabs__header")[0]
        ? document.getElementsByClassName("el-tabs__header")[0].clientHeight
        : 0;

      const customHeader = document.getElementsByClassName(
        "table-custom-header "
      )[0]
        ? document.getElementsByClassName("table-custom-header ")[0]
            .clientHeight
        : 0;
      if (value) {
        this.tableHeight =
          window.innerHeight -
          (navH + tagH + searchH + pagerH + bottomH + tabH + customHeader + 75);
      }
    },
    //toggleRowSelections
    data: {
      handler: function (val) {
        this.$emit("update:refObj", this.$refs.table);
        this.$nextTick(() => {
          this.toggleRowData();
        });
      },
      deep: true, // 深度监听
    },
    // toggleRowSelections: {
    //   handler: function (val) {
    //     alert('深度')
    //     this.$emit('update:refObj', this.$refs.table)
    //   },
    //   deep: true // 深度监听
    // },
  },
  mounted() {
    this.$emit("update:refObj", this.$refs.table);
    this.toggleRowData();
  },
  methods: {
    //创建二维码
    createQrcode(ref, text){
      console.log('qr_code', text)
      this.$nextTick(() => {
        if(this.qrCode){
          this.qrCode.clear();
        }
        this.$refs[ref][0].innerHTML = '';
        this.qrCode = new QRCode(this.$refs[ref][0], {
          text, // 需要转换为二维码的内容
          width: 200, //宽度
          height: 200, //高度
          colorDark: '#000000', //二维码方块颜色
          colorLight: '#ffffff', //背景颜色
          correctLevel: QRCode.CorrectLevel.Q, //容错率：L M Q H 依次递减
        })
      })
    },
    //保存二维码图片
    saveQrImg(ref){
      try {
        //找到需要转换的canvas
        var data = this.$refs[ref][0].children[0].toDataURL().replace("image/png",
          "image/octet-stream;"); //获取二维码值，并修改响应头部。
        var filename = `qr-${new Date().getTime()}.png`; //保存的图片名称和格式，canvas默认使用的png格式。这个格式效果最好。
        var save_link = document.createElement('a');
        save_link.href = data;
        save_link.download = filename;
        save_link.click()
      } catch (e) {
        console.log(e)
        this.$message.error(e)
      }
    },
    handleSizeChange(val) {
      const query = this.listInfo.query;
      query.pageSize = val; // 每页条数
      query.curPage = 1; // 每页条数切换，重置当前页
    },
    handleCurrentChange(val) {
      this.listInfo.query.curPage = val; // 当前页
    },
    // 派发按钮点击事件
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
    // 派发按钮自定义事件
    handleEvent(event, data) {
      this.$emit("handleEvent", event, data);
    },
    // 选中数据
    handleSelectionChange(rows) {
      this.$emit("handleEvent", "tableCheck", rows);
    },
    //
    toggleRowData() {
      this.$emit("update:refObj", this.$refs.table);
      //
      if (this.toggleRowSelections && this.data) {
        this.data.forEach((item, index) => {
          this.toggleRowSelections.forEach((items, indexs) => {
            if (this.data[index].id === this.toggleRowSelections[indexs]) {
              this.$refs.table.toggleRowSelection(this.data[index], true);
            } else if (
              this.data[index].pageOpId === this.toggleRowSelections[indexs]
            ) {
              this.$refs.table.toggleRowSelection(this.data[index], true);
            } else if (
              this.data[index].roleId === this.toggleRowSelections[indexs]
            ) {
              this.$refs.table.toggleRowSelection(this.data[index], true);
            }
          });
        });
      }
      //
    },
  },
};
</script>
<style scoped>
.qrPic{
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/table.vue